import React, { ReactElement } from 'react'
import styled from 'styled-components'

import { Warning } from 'shared/timber/hydrogen/icons'
import Tooltip from '~/views/components/ui/Tooltip'

const IconWrapper = styled.div`
  display: inline;
  position: relative;
  top: 0.25em;
  height: 15px;
`

const WarningIcon = styled(Warning)`
  & path {
    stroke: rgb(253, 142, 35);
  }
`

const StyledTooltip = styled(Tooltip)`
  .tooltip {
    background-color: rgb(250, 240, 230);
    border: 1px solid rgb(253, 142, 35);
    padding: 1em 1.5em;
    box-shadow: none;
  }
`

type WarningIconAndTooltipProps = {
  iconStyle?: React.CSSProperties
  children: ReactElement
  tooltipClassName?: string
  iconClassName?: string
}

export default function WarningIconAndTooltip({
  children,
  tooltipClassName,
  iconClassName,
  iconStyle,
}: WarningIconAndTooltipProps) {
  return (
    <IconWrapper aria-label="warning-icon" style={iconStyle}>
      <StyledTooltip
        title={children}
        placement="top"
        className={`project-overview-tooltip ${tooltipClassName || ''}`}
      >
        <WarningIcon
          className={`project-overview-warning-icon ${iconClassName || ''}`}
        />
      </StyledTooltip>
    </IconWrapper>
  )
}
